<form [formGroup]="form" (ngSubmit)="onSubmit($event)">
  <fieldset>
    <legend>Inserisci parametri di ricerca: <small class="sr-only">protocollo ricerca</small> </legend>
    <div class="">
      <div *ngFor="let formField of formFields" class="col-xs-12 col-sm-6">
        <dynamic-form-field [form]="form" [question]="formField" (onChangeValue)="onFormFieldEvent($event)" />
      </div>
    </div>
    <div class="col-xs-12 col-sm-6"></div>
    <div class="row">
      <p class="col-sm-12 mandatory" style="padding-left: 15px!important; padding-right: 15px!important;">
        <em [ngStyle]="{ 'margin-left': isDocumentazione ? '2%' : '0' }" >* Campi obbligatori</em>
      </p>
    </div>
    <div class="row buttons" [ngClass]="{ 'no-margin': isDocumentazione }">
      <div class="col-xs-6 col-sm-3" style="padding-left: 15px!important; padding-right: 15px!important;">
        <button class="btn btn-outline-secondary btn-block" type="button" (click)="onReset()">
          Reset
        </button>
      </div>
      <div class="col-sm-3 col-sm-offset-6 col-xs-6"
        style="padding-left: 15px!important; padding-right: 15px!important;">
        <button class="btn btn-primary btn-block" [disabled]="!isFormValid()" type="submit">Cerca</button>
      </div>
    </div>
  </fieldset>
</form>

<div #target>
  <div *ngIf="result" >
    <p class="title-search-result">Anteprima risultato</p>
    <div>
      <div class="titletogglepanel">
        <a data-toggle="collapse" (click)="openDetail($event, i)" href="javascript:void(0)" aria-expanded="false"
          [ngClass]="openAccordion ? 'collapsed' : 'collapse'">
          <div class="row infos">
            <div class="col-sm-2">
              <button class="btn btn-primary btn-block" aria-label="Importa dati" [disabled]="!checkValidity()" (click)="importData($event)">Importa</button>
            </div>
            <div class="col-sm-7">
              <span>Mittente / Destinatario:</span>
              <span style="color: #aeaeae;">{{result.metadata.senderReceiver}}</span>
            </div>
            <div class="col-sm-3">
              <span>Numero protocollo:</span>
              <span style="color: #aeaeae;">{{result.metadata.sigla}}/{{result.metadata.protocolYear}}/{{result.metadata.protocolNumber}}</span>
            </div>
          </div>
        </a>
      </div>
      <div id="{{result.metadata.idDoc}}" [ngClass]="openAccordion  ? 'collapsed' : 'collapse'"
        style="padding-top: 25px;">
        <div class="">
          <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Numero protocollo'"
            [valueInput]="result.metadata.sigla + '/' + result.metadata.protocolYear + '/' + result.metadata.protocolNumber"></div>
          <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Data Protocollo'"
            [valueInput]="result.metadata.protocolTimestamp"></div>
          <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Registrazione'"
            [valueInput]="result.metadata.tipoReg"></div>
          <div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'textarea'" [labelInput]="'Mittente / Destinatario'"
            [valueInput]="result.metadata.senderReceiver"></div>
          <div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'textarea'" [labelInput]="'Oggetto'"
            [valueInput]="result.metadata.subject"></div>
        </div>
        <!-- <ng-template [ngIf]="result.documenti.length > 0">
          <ul documenti_allegati_lista=""
            class="documenti-list"
            [documenti]="result.documenti" 
            [fascicolo]="null" 
            [subdoc]="false">
          </ul>
        </ng-template> -->

        <!--INSERIMENTO DOCUMENTI-->

        <div *ngIf="!isDocumentInserted" style="margin-top: 20px">
          <div class="row">
            <div class="col-sm-9" style="padding-left: 15px;">
              <div class="row" style="margin-top: 20px;margin-bottom: 10px;">
                <div class="col-sm-12">
                  <div *ngIf="fileUploadList && fileUploadList.length > 0">
                    <div *ngFor="let item of fileUploadList; let index = index">
                      <app-document-uploaded 
                        [indexFile]="index" 
                        [tipiDocumentoOptions]="tipoDocumentoOption" 
                        (onReturn)="onDocReturn($event)"
                        (onExtract)="onExtractArchive($event)"
                        [protocol]="true"
                        (onRemoveFile)="deleteFile($event.refDocumentale, index)" 
                        [file]="item">
                      </app-document-uploaded>
                    </div>
                  </div>
                  <!-- <table class="tg" *ngIf="fileUploadList && fileUploadList.length > 0">
                    <caption class="sr-only">Tabella lista file caricati</caption>
                    <tr>
                      <th colspan="2" scope="col">Nome File</th>
                      <th colspan="2" scope="col">Primario</th>
                      <th colspan="4" scope="col" style="text-align: center">Tipologia Documento <span _ngcontent-c10=""class="mandatory ">*</span></th>
                      <th colspan="2" scope="col"></th>
                    </tr>
                    <tr *ngFor="let item of fileUploadList; let index = index">
                      <td colspan="2">
                        <p class="file_name">{{item.nomeFile}}</p>
                      </td>
                      <td colspan="2" style="text-align: center">
                        <input type="radio" name="" style="width: 16px !important;height: 16px !important;position: relative !important;margin: 0;" class="is-primary" title="Imposta come primario" (click)="changePrimary(item.refDocumentale)"
                          [checked]="getPrimary(item.refDocumentale)">
                      </td>
                      <td colspan="4">
                        <label for="tipo_doc" class="sr-only">Tipologia Documento</label>
                        <select #typeDocSelect id="tipo_doc" class="form-control" (change)="onTypeDocChange($event, item)">
                          <option value="null">Seleziona Tipologia documento</option>
                          <option value="{{item.descrizione}}" *ngFor="let item of tipoDocumentoOption | filterDocumentType: getPrimary(item.refDocumentale) : item">
                            {{item.descrizione}}
                          </option>
                        </select>
                      </td>
                      <td colspan="2" class="tg-oy1"><span style="text-align: center;color:#0b59a4;cursor: pointer;" class="glyphicon glyphicon-trash"
                          (click)="deleteFile(item.refDocumentale, index)"></span>
                      </td>
                    </tr>
                  </table> -->
                </div>
              </div>
            </div>
            <div class="col-sm-3" style="display: flex; justify-content: end;">
              <app-upload-tool [standard]="true" (onChange)="onSearchChange($event)">
              </app-upload-tool>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-7"></div>
            <div class="col-sm-5" style="text-align: end;">
              <div *ngIf="maxFileSize" class="error-msg" style="margin-top:2%;">
                La dimensione massima dei documenti non può eccedere i {{ maxFileSizeMB }} MB
              </div>
            </div>
          </div>
        </div>
      
        <div class="uploaded-docs" *ngIf="listaDocumenti && listaDocumenti.length > 0">
          <!-- <p>Documenti precedentemente caricati</p> -->
          <table class="table-striped table col-xs-12">
            <caption class="sr-only">Tabella lista documenti</caption>
            <tbody>
              <tr>
                <th width="20%">Nome File</th>
                <th>Tipologia Documento</th>
                <th>Primario</th>
              </tr>
              <tr *ngFor="let item of listaDocumenti; let index = index">
                <td>
                  <p class="file_name">{{item.nomeFile}}</p>
                </td>
                <td>
                  {{item.tipoDocumento.descrizione}}
                </td>
                <td>
                  <strong class="color: red">{{item.primary ? "Sì" : "No"}}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!--FINE INSERIMENTO DOCUMENTI-->

      </div>
    </div>
  </div>
</div>

